// =====================================================================
// CommissionRuleDialog (Financeiro F2-ext / S59) — regra de comissão (% por profissional).
// Upsert pela chave (profissional + serviço NULL = regra padrão). v1 = regra padrão.
// =====================================================================
import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  MenuItem, Typography, CircularProgress
} from "@material-ui/core";
import { toast } from "react-toastify";
import { upsertCommissionRule, financeErrorMessage } from "../../services/financeService";
import useIsMobile from "../../utils/useIsMobile";

const CommissionRuleDialog = ({ open, rule, professionals, onClose, onSaved }) => {
  const isMobile = useIsMobile();
  const editing = !!rule;
  const [professionalId, setProfessionalId] = useState("");
  const [percent, setPercent] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setProfessionalId(rule?.professionalId ? String(rule.professionalId) : "");
      setPercent(rule?.percent != null ? String(rule.percent) : "");
    }
  }, [open, rule]);

  const handleSave = async () => {
    if (!professionalId) { toast.error("Selecione o profissional."); return; }
    const p = Number(String(percent).replace(",", "."));
    if (!(p >= 0 && p <= 100)) { toast.error("O percentual deve estar entre 0 e 100."); return; }
    setSaving(true);
    try {
      await upsertCommissionRule({ professionalId: Number(professionalId), percent: p, active: true });
      toast.success("Regra de comissão salva.");
      onSaved && onSaved();
    } catch (err) {
      toast.error(financeErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth fullScreen={isMobile}>
      <DialogTitle>{editing ? "Editar regra de comissão" : "Nova regra de comissão"}</DialogTitle>
      <DialogContent>
        <TextField select label="Profissional" value={professionalId} onChange={(e) => setProfessionalId(e.target.value)}
          fullWidth margin="dense" disabled={editing}>
          {(professionals || []).map((p) => <MenuItem key={p.id} value={String(p.id)}>{p.name}</MenuItem>)}
        </TextField>
        <TextField label="Comissão (%)" type="number" value={percent} onChange={(e) => setPercent(e.target.value)}
          fullWidth margin="dense" inputProps={{ step: "0.01", min: "0", max: "100" }} autoFocus />
        <Typography variant="caption" color="textSecondary">
          Aplicada sobre o valor <strong>recebido</strong> de cada pagamento dos orçamentos desse profissional.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}
          startIcon={saving ? <CircularProgress size={16} /> : null}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommissionRuleDialog;
